module.exports = __webpack_public_path__ + "img/robot06.c1c9c856.png";